// When the world stage holds its last frame under an overlay (stint 3, the Switch → Dad root
// cause): any modal sheet, which makes the page behind inert anyway. Not the World panel (it's not
// modal: time and weather show live), nor a stop or place card (the camera moves to what it's about).
export function worldHoldsUnder(overlay: string | null): boolean {
  return !!overlay && overlay !== 'world' && !overlay.startsWith('stage:') && !overlay.startsWith('place:')
}
